import { StyleProvider } from "@ant-design/cssinjs";
import { QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp, ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import thTH from "antd/locale/th_TH";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RouterProvider } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { setDayjsLocale } from "@/lib/dayjs";
import { queryClient } from "@/lib/query-client";
import { router } from "@/routes";
import theme from "@/theme/tokens";

export function App() {
  const { t } = useTranslation();
  const { language } = useLanguage();

  useEffect(() => {
    setDayjsLocale(language);
  }, [language]);

  // index.html is static, so the tab title and the document language would
  // otherwise stay Thai for an English reader — including for screen readers,
  // which use `lang` to pick a voice. The <meta>/OG tags deliberately stay
  // Thai: they are crawler-facing and this is a Thai-market product.
  useEffect(() => {
    document.documentElement.lang = language;
    document.title = t("common:document.title");
  }, [language, t]);

  const antdLocale = language === "en" ? enUS : thTH;

  return (
    <QueryClientProvider client={queryClient}>
      <StyleProvider layer>
        <ConfigProvider theme={theme} locale={antdLocale}>
          <AntApp>
            <RouterProvider router={router} />
          </AntApp>
        </ConfigProvider>
      </StyleProvider>
    </QueryClientProvider>
  );
}
